import React from 'react';
import { Typography } from '../../index';
import './link.scss';

const NightingaleLink = ({
    as,
    children,
    className,
    colorStyle = 'default',
    color,
    decorator = 'always',
    disabled = false,
    display,
    href,
    onClick,
    responsive,
    target,
    typographyType,
    underline = "none",
    variant = 'inline',
    ...linkProps
}) => {

    const style = { display: `${display}` };
    const linkClasses = [
        `bsw-link`,
        `bsw-link-color--${colorStyle}`,
        `bsw-link-decorator--${decorator}`,
        `bsw-link-underline--${underline}`,
        `bsw-link--${variant}`,
        `${disabled ? 'bsw-link--disabled' : ''}`,
        `${className ? className : ''}`,
    ].join(' ');

    const linkContent = <Typography
        type={typographyType}
        color={disabled ? "$color-secondary-a3" : color ? color : ''}
        responsive={responsive}
    >
        {children}
    </Typography>;

    const linkAs = disabled ? <span></span> : (as ? as : <a href={href}></a>);

    const linkElem = React.cloneElement(
        linkAs,
        {
            ...linkProps,
            className: linkClasses,
            onClick: onClick,
            style: style,
            target: target 
        },
        linkContent
    );

    return (
        <>
            {linkElem}
        </>
    );
};

export default NightingaleLink;